import React from 'react';
import { stopAutoPlayArr } from '../../../../enums';
import { StopRound } from '../../../../components/common/bettingPart';

export const StopAutoRound = ({ t, limits, handleOpenNumPad }) => {
  return (
    <div className='bet-sec-row'>
      <div className='bet-sec-col'>
        {stopAutoPlayArr.map((marketName) => (
          <StopRound
            key={marketName}
            t={t}
            marketName={marketName}
            limits={limits}
            handleOpenNumPad={handleOpenNumPad}
          />
        ))}
      </div>
    </div>
  );
};
